export const defaultWeapon = {
  name: null,
  nameUnique: null,
  countPerUnit: 1,
  type: null,
  attacks: null,
  bs: null,
  ws: null,
  strength: null,
  ap: 0,
  damage: null,
  abilities: [],
  id: null,
}
